import React from 'react'
import { withPrefix } from 'gatsby'
import { PillButton } from '../../../general/buttons/pill-button'
import { SmallHeadline } from '../../../general/headlines'
import RichText from '../../../general/rich-text/RichText'

const LearnMoreSection = React.memo(({data}) => {
    return (
        <div key="lm-s" className='learn-more-section flex--center'>
            <div className='elevate'>
                <div className="text-section">
                    <RichText>{data.homePageGivingTuesdayCopy}</RichText>
                </div>

                <a 
                    href="https://www.givingtuesday.org/"
                    target="_blank"
                >
                    <PillButton actionType="external-link" action="givingtuesday.org">Learn More</PillButton>
                </a>
            </div>

            <LearnMoreSectionBackgroundImages/>
            
            <style jsx>{`
                .learn-more-section {
                    background: var(--color--blue);
                    text-align: center;
                    height: 300px;
                    position: relative;
                }


                .text-section {
                    margin-bottom: 30px;
                }

                .learn-more-section :global(p) {
                    color: white;
                    max-width: 600px;
                }

                @media (pointer: coarse), (max-width: 769px) {
                    .learn-more-section {
                        height: 500px;
                    }

                    .text-section {
                        padding: 20px;
                    }
                }
            `}</style>
        </div>
    )
})

const LearnMoreSectionBackgroundImages = () => {
    return (
        <>
            <img className='lmbg-book' src={withPrefix('/images/home-book-2x.webp')} alt="" />
            <img className='lmbg-shoe' src={withPrefix('/images/home-shoe-2x.webp')} alt="" />

            <style jsx>{`

                .lmbg-book {
                    position: absolute;
                    left: 80px;
                    width: 250px;
                }

                .lmbg-shoe {
                    position: absolute;
                    right: 60px;
                    bottom: 90px;
                    z-index: 0;
                    width: 280px;
                }
                @media (pointer: coarse), (max-width: 769px) {
                    .lmbg-book {
                        position: absolute;
                        left: 50%;
                        transform: translateX(-40%);
                        top: 0px;
                        width: 180px;
                    }
    
                    .lmbg-shoe {
                        position: absolute;
                        left: 50%;
                        transform: translateX(-50%);
                        top: initial;
                        bottom: 40px;
                        width: 220px;
                    }
                }
            `}</style>
        </>
    )
}



export default LearnMoreSection